var path = 'app/scripts/modules/azure/src/serverGroup/configure/wizard/capacity/capacity.html';
var html = "<div class=\"clear-fix\">\n  <div class=\"col-md-12\">\n    <azure-server-group-capacity-selector command=\"command\"></azure-server-group-capacity-selector>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;